class SmgTestimonialsSlider extends HTMLElement {
  connectedCallback() {
    // Wait for Swiper to be available
    const init = () => {
      const swiperEl = this.querySelector('.swiper');
      if (!swiperEl || !window.Swiper) {
        requestAnimationFrame(init);
        return;
      }

      const navAttr = this.getAttribute('data-navigation') || '';
      const [prevSel, nextSel] = navAttr.split(',');
      const autoplayDelay = parseInt(this.getAttribute('data-autoplay') || '0', 10);
      const mobileSlides = parseInt(this.getAttribute('data-slides-mobile') || '1', 10);
      const desktopSlides = parseInt(this.getAttribute('data-slides-desktop') || '2', 10);
      const spaceBetween = parseInt(this.getAttribute('data-space-between') || '20', 10);

      const config = {
        slidesPerView: mobileSlides,
        spaceBetween,
        autoHeight: true,
        loop: false,
        watchSlidesProgress: true,
        navigation: {
          prevEl: prevSel || undefined,
          nextEl: nextSel || undefined,
        },
        breakpoints: {
          0: { slidesPerView: 1.15 },
          1001: { slidesPerView: 1.9 },
        },
      };

      if (autoplayDelay > 0) {
        config.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false,
          // Slides are whole-card links, so autoplay must hold while the
          // pointer is over the track: otherwise the card the user aimed at
          // slides away and the click lands on its neighbour.
          pauseOnMouseEnter: true,
        };
      }

      this._swiper = new Swiper(swiperEl, config);

      // Bind multiple external nav buttons if duplicates exist (top and bottom)
      if (prevSel) {
        document.querySelectorAll(prevSel).forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            try { this._swiper.slidePrev(); } catch (err) {}
          });
        });
      }
      if (nextSel) {
        document.querySelectorAll(nextSel).forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            try { this._swiper.slideNext(); } catch (err) {}
          });
        });
      }

      // Re-measure height after images load
      swiperEl.querySelectorAll('img').forEach((img) => {
        if (!img.complete) {
          img.addEventListener('load', () => {
            try { this._swiper.updateAutoHeight(300); } catch (e) {}
          }, { once: true });
        }
      });
    };

    init();
  }
}

customElements.define('smg-testimonials-slider', SmgTestimonialsSlider);
